// DTOs de WS-8 P3 — Nivel de servicio (módulo Facturación del coordinador).
//
// Réplica del Excel "Niveles de servicio (Dashboard)" hoja DATOS: rollup
// SEMANAL por ACTIVIDAD (área) del cruce por OP:
//   SEM · ACTIVIDAD · UNDS PROGRAMADAS · UNDS REALIZADAS · CUMPLIMIENTO ·
//   UNDS NO ENTREGADAS · % NO ENTREGADAS · CUMPLIMIENTO REAL
//
// Decisiones (2026-07-02, usuario):
//   - Realizadas = producción CAPTURADA del líder (así arma hoy el Excel);
//     la parte validada por supervisor se expone aparte (✓). P4 factura
//     SOLO validado.
//   - No entregadas = no_entregada_justificada con causa CLIENTE (el CHECK
//     de mig 54 garantiza que causa interna siempre tiene 0) → REAL =
//     (realizadas + no_entregadas) / programadas.
//   - La semana de una OP es la semana ISO de su PRIMERA fecha programada;
//     las OPs sin programar no entran al nivel de servicio.
//
// Endpoint:
//   GET /api/coordinador/facturacion/nivel-servicio?desde&hasta&cliente_id
import { z } from 'zod';
export const nivelServicioQuerySchema = z.object({
    desde: z.string().date(),
    hasta: z.string().date(),
    cliente_id: z.string().uuid().optional(),
});
/** Fila del rollup: una por (semana ISO, actividad/área). */
export const nivelServicioFilaSchema = z.object({
    semana_iso: z.string(),
    area_id: z.string().uuid(),
    area_codigo: z.string(),
    area_nombre: z.string(),
    planta_nombre: z.string(),
    ops: z.number().int().min(0),
    programadas: z.number(),
    /** Capturada del líder (como el Excel). */
    realizadas: z.number(),
    /** Parte validada por supervisor (base de facturación). */
    validadas: z.number(),
    /** realizadas/programadas ×100. NULL si programadas=0. */
    cumplimiento_pct: z.number().nullable(),
    /** No entregadas por el CLIENTE (justificadas en el cruce). */
    no_entregadas: z.number(),
    /** no_entregadas/programadas ×100. NULL si programadas=0. */
    pct_no_entregadas: z.number().nullable(),
    /** (realizadas + no_entregadas)/programadas ×100. NULL si programadas=0. */
    cumplimiento_real_pct: z.number().nullable(),
});
/** Total por semana (todas las actividades). */
export const nivelServicioSemanaSchema = z.object({
    semana_iso: z.string(),
    programadas: z.number(),
    realizadas: z.number(),
    validadas: z.number(),
    no_entregadas: z.number(),
    cumplimiento_pct: z.number().nullable(),
    cumplimiento_real_pct: z.number().nullable(),
});
/** Cumplimiento por DÍA (vista tabla del "% nivel de servicio"). Programadas
 * por fecha programada; realizadas = producción capturada ese día de las OPs
 * programadas en el rango. */
export const nivelServicioDiaSchema = z.object({
    fecha: z.string().date(),
    programadas: z.number(),
    realizadas: z.number(),
    validadas: z.number(),
    no_entregadas: z.number(),
    cumplimiento_pct: z.number().nullable(),
    cumplimiento_real_pct: z.number().nullable(),
});
export const nivelServicioSchema = z.object({
    desde: z.string().date(),
    hasta: z.string().date(),
    filas: z.array(nivelServicioFilaSchema),
    semanas: z.array(nivelServicioSemanaSchema),
    dias: z.array(nivelServicioDiaSchema),
    acumulado: z.object({
        programadas: z.number(),
        realizadas: z.number(),
        validadas: z.number(),
        no_entregadas: z.number(),
        cumplimiento_pct: z.number().nullable(),
        cumplimiento_real_pct: z.number().nullable(),
    }),
    clientes: z.array(z.object({ id: z.string().uuid(), nombre: z.string(), es_principal: z.boolean() })),
});
//# sourceMappingURL=coordinador_facturacion_nivel.js.map